// For the price list change event
$(document).ready(function(){
    console.log('ready function 51');
    const priceListSelector = '.catelog-list .categlog-price-dropdown a,.price-list-mobile .lvl-1 a,.b2b-mobile-price-list a';
    
        $(document).on('click', priceListSelector, function(event){
            event.preventDefault();
            event.stopImmediatePropagation();
            let currentData = $(this);
            let locationUrl = currentData.attr('data-link');
            if (!locationUrl) return;
            if (typeof clearQuickOrderData === 'function') clearQuickOrderData();
                $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                complete: function(){
                    window.location.assign(locationUrl)
                },
                dataType: 'json'
            });
        }) 
    
})


$(document).ready(function(){
    $(document).on("click",'#cart-drawer .item-remove .remove',function(event) {
    event.preventDefault()
      if($(this).attr('datatemplok')){
      let templokId = parseInt($(this).parents('li').attr('itemid'));
      let regularId = parseInt($(this).attr('datatemplok'));
      let data = {};
      if(!isNaN(templokId)){
      data[templokId] = 0
      }
      if(!isNaN(regularId)){
        data[regularId] = 0
      }
      CartJS.updateItemQuantitiesById(data);
    }
    })
    $(document).on('cart.requestComplete', function(event, cart) {
       // ECOMM-63 check for moz design products in cart and enable or disable express checkout buttons
        let mozVendorCount = 0;
        const targetVendor = "Moz Designs";
         $.each(cart.items, function(listItem, item) {
             if (item.vendor.toLowerCase() === targetVendor.toLowerCase()) {
                mozVendorCount = mozVendorCount + 1;
            }
        //     if(item.properties) {
        //         $.each(item.properties, function(title, value) {
        //             if(title == '_templokRegularVariantId' && value != ''){
        //                 $('.remove[datatemplok='+value+']').removeAttr('rv-data-cart-remove');
        //                 $('.remove[datatemplok='+value+']').removeAttr('data-cart-remove');
        //             }
        //         })
        //     }
         })

           if (mozVendorCount > 0){
            console.log("mozVendorCount > 0 hide ",mozVendorCount)
            $('.additional-checkout-buttons').addClass('tw-hidden');
           } else {
            $('.additional-checkout-buttons').removeClass('tw-hidden');
            console.log("mozVendorCount show",mozVendorCount)
           }
    });
    $.getJSON('/cart.js', async function(cart) {
        $.each(cart.items, function(listItem, item) {
            if(item.properties) {
                $.each(item.properties, function(title, value) {
                    if(title == '_templokRegularVariantId' && value != ''){
                        $('.remove[datatemplok='+value+']').removeAttr('rv-data-cart-remove');
                        $('.remove[datatemplok='+value+']').removeAttr('data-cart-remove');
                    }
                })
            }
        })
    })
})


// Automatically style trademark and registered symbols in product titles
function styleTrademarkSymbols() {
    const productTitles = document.querySelectorAll('.product-single__title');
    
    productTitles.forEach(function(titleElement) {
        let html = titleElement.innerHTML;
        
        // Replace ® and ™ with wrapped versions
        html = html.replace(/®/g, '<sup class="trademark-symbol">®</sup>');
        html = html.replace(/™/g, '<sup class="trademark-symbol">™</sup>');
        
        titleElement.innerHTML = html;
    });
}

// Run on page load for product pages
if (window.location.pathname.includes('/products/')) {
    $(document).ready(function() {
        styleTrademarkSymbols();
    });
}
